module.exports = __webpack_public_path__ + "9b471a4b532fc5086ef67289efcc1efb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/catholic_investor.png
// module id = 1643
// module chunks = 0